import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { ButtonConfig } from '../../../interfaces';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'hmax-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoModule, CapitalizePipe, MatProgressSpinnerModule],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  private _router = inject(Router);

  @Input() button!: ButtonConfig;
  @Input() class!: string;
  @Output() buttonClick = new EventEmitter<string>();

  hasLabel = false;

  ngOnInit(): void {
    this.hasLabel = this.button?.label != null;
  }

  onClick(): void {
    const { label, routerLink, href, target } = this.button;
    if (routerLink) {
      this._router.navigate([routerLink]);
      return;
    } else if (href) {
      window.open(href, target ?? '_blank');
    }

    this.buttonClick.emit(label);
  }
}
